import { draftToSavePayload } from "@/lib/formBuilder/draft";
import type { ApiFieldTypeOption } from "@/lib/formBuilder/apiFieldTypes";
import type { FormBuilderDraft } from "@/types/formBuilder";
import type { FormBuilderMeta } from "./types";

export function buildFormSchemaExport(
  draft: FormBuilderDraft,
  meta: FormBuilderMeta,
  formId: number | null,
  fieldTypes: ApiFieldTypeOption[],
): object {
  return {
    exportedAt: new Date().toISOString(),
    formId,
    meta,
    draft,
    savePayload: draftToSavePayload(draft, {
      fieldTypes,
      organisationId: meta.organisationId,
      externalServiceId: meta.externalServiceId,
    }),
  };
}

export function downloadFormSchemaJson(
  payload: object,
  formId: number | null,
): void {
  const blob = new Blob([JSON.stringify(payload, null, 2)], {
    type: "application/json",
  });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download =
    formId != null ? `form-${formId}-schema.json` : "form-schema.json";
  anchor.click();
  URL.revokeObjectURL(url);
}
